import Vue from 'vue';
import Router from 'vue-router';
import store from './store.js'; //服务市场 - 重构
import notice from './notice.js'; //通知公告 - 重构
import approve from './approve.js'; //高级审批 - 重构
import purchase from './purchase.js'; //产品 - 采购
import warehouse from './warehouse.js'; //仓库
import complain from './complain.js'; //聊天投诉
import guide from './guide.js'; //聊天投诉

Vue.use(Router);
// () => import('@/views/login/index')
let routes = [...store, ...notice, ...approve, ...warehouse, ...purchase, ...complain, ...guide,
    {
        path: '/test',
        name: 'test',
        meta: {
            title: '测试',
            company: true
        },
        component: () => import('../views/test/test')
    },
    {
        path: '/private',
        name: 'private',
        meta: {
            title: '测试',
            company: true
        },
        component: () => import('../views/private/index')
    },
    {
        path: '/test/icuOrder',
        name: 'icuOrder',
        meta: {
            title: '加班餐',
            company: true
        },
        component: () => import('../views/test/icuOrder')
    }];

// scrollBehavior:
// - only available in html5 history mode
// - defaults to no scroll behavior
// - return false to prevent scroll
// const scrollBehavior = (to, from, savedPosition) => {
//     if (savedPosition) {
//       // savedPosition is only available for popstate navigations.
//       return savedPosition;
//     }
//       const position = {};
//       // new navigation.
//       // scroll to anchor by returning the selector
//       if (to.hash) {
//         position.selector = to.hash;
//       }
//       // check if any matched route config has meta that requires scrolling to top
//       if (to.matched.some(m => m.meta.scrollToTop)) {
//         // cords will be used if no selector is provided,
//         // or if the selector didn't match any element.
//         position.x = 0;
//         position.y = 0;
//       }
//       // if the returned position is falsy or an empty object,
//       // will retain current scroll position.
//       return position;
//   };

export default new Router({
    routes,
    mode: 'history',
    // base: '/new/',
    // scrollBehavior
    scrollBehavior(to, from, savedPosition) {
        console.log('scrollBehavior', to.meta.keepAlive);
        if (savedPosition) {
            return savedPosition;
        }
        if (!to.meta.keepAlive) {
            return {
                x: 0,
                y: 0
            };
        }
    }
});
